import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import Typography from '../components/Typography';
import AppBar from '../components/AppBar';
import Toolbar from '../components/Toolbar';
import { createTheme } from '@mui/material/styles';
import logo from '../images/caavlogo.png';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

function AppAppBar() {
  const [open, setOpen] = React.useState(false);

  const openContactModal = () => {
    if(open == true){
      setOpen(false);
    }else{
      setOpen(true);
    }
  }

  const closeContactModal = () => {
    setOpen(false);
  }

  return (
    <div>
      <AppBar position="fixed">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ flex: 1 }} />
          {/* <Link
            variant="h6"
            underline="none"
            color="inherit"
            href="/premium-themes/onepirate/"
            sx={{ fontSize: 24 }}
          >
            {'onepirate'}
          </Link> */}
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={openContactModal} variant="h6">{'Contacto'}</Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Drawer
        anchor="right"
        open={open}
        onClose={closeContactModal}
        sx={{ zIndex: 0, opacity: .95 }}
      >
          <Box align="center" sx={{ 
              height: "100vh", 
              backgroundColor: "#00496C", 
              paddingTop: "90px", 
              paddingLeft: "20px",
              paddingRight: "20px",
              [theme.breakpoints.down('sm')]: {
                width: "100vw",
              },
              [theme.breakpoints.up('sm')]: {
                width: "50vw",
              } 
            }}
          >
            <img
              src={logo}
              alt="logo"
              width="200"
              height="66"
              style={{ display: "block", marginRight: "auto", marginLeft: "auto" }}
            />
            <PhoneEnabledIcon fontSize='medium' sx={{mt: "32px"}}/>
            <Typography variant="h6" color="inherit">
              33 36 15 29 64
            </Typography>
            <Typography variant="h6" color="inherit">
              33 35 87 78 25
            </Typography>
            <Typography variant="h6" color="inherit">
              33 35 87 78 24
            </Typography>
            <Typography variant="h6" color="inherit">
              33 36 15 84 70
            </Typography>
            <EmailIcon fontSize='medium' sx={{mt: "32px"}}/>
            <Typography variant="h6" color="inherit">
              muestra@caav.mx
            </Typography>
            <LocationOnIcon fontSize='medium' sx={{mt: "32px"}}/>
            <Typography variant="h6" color="inherit">
              Lerdo de Tejada 2071,
            </Typography>
            <Typography variant="h6" color="inherit">
              entre Marsella y Av. Chapultepec
            </Typography>
            <Typography variant="h6" color="inherit">
              Colonia Americana,
            </Typography>
            <Typography variant="h6" color="inherit">
              Guadalajara, Jalisco, México.
            </Typography>
          </Box>
      </Drawer>
    </div>
  );
}

export default AppAppBar;